import { writable } from "svelte/store"

const defaultOrder = {
  startDate: "",
  endDate: "",
  underlyingSymbol: "",
  status: [] as string[],
  receivedAt: "",
  days: 0 as number | null,
}

export type OrderStoreState = typeof defaultOrder

const store = writable(structuredClone(defaultOrder))

export const orderStore = {
  ...store,
  reset: () => store.set(structuredClone(defaultOrder)),
}
